import React, { useState, useEffect, Fragment } from 'react';
import { useMediaQuery, FormGroup, FormControl, Link } from '@material-ui/core';
import clsx from 'clsx';
import { useFormInput, PageContainer, Col, Typography, Input, PrimaryButton, Row, RightPlaceholder, CopyrightAgentLoader, Icons, SecondaryButton } from '@copyrightagent/basic-components';
import axios from 'axios';
import { makeStyles } from '@material-ui/styles';
import { Trans } from 'react-i18next';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function getUser(token, api) {
  return __awaiter(this, void 0, void 0, function () {
    var config, res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          config = {
            method: 'get',
            url: api + "/me",
            headers: {
              'Content-Type': 'application/json',
              'X-Copyright-Agent-Auth-Token': token
            }
          };
          return [4
          /*yield*/
          , axios(config)];

        case 1:
          res = _a.sent();
          return [2
          /*return*/
          , res];
      }
    });
  });
}

function login(email, password, api) {
  return __awaiter(this, void 0, void 0, function () {
    var config, res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          config = {
            method: 'post',
            url: api + "/authentication/login",
            headers: {
              'Content-Type': 'application/json',
              'X-Copyright-Agent-Auth-Token': ''
            },
            data: {
              email: email,
              password: password
            }
          };
          return [4
          /*yield*/
          , axios(config)];

        case 1:
          res = _a.sent();
          return [2
          /*return*/
          , res];
      }
    });
  });
}

var dark50$1 = '#8E939B';
var useStyle$1 = makeStyles(function (theme) {
  return {
    page: {
      display: 'flex',
      minHeight: '100vh',
      flexDirection: 'row'
    },
    form: {
      width: '60%',
      minHeight: 320,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    submitButton: {
      width: '37.5%',
      padding: '15px 20px',
      textTransform: 'none'
    },
    selfCenter: {
      alignSelf: 'center'
    },
    selfEnd: {
      alignSelf: 'flex-end'
    },
    selfStart: {
      alignSelf: 'flex-start'
    },
    formTitle: {
      marginLeft: 10,
      marginBottom: 25
    },
    leftCol: {
      flex: 1,
      backgroundColor: 'white'
    },
    bottom: {
      position: 'absolute',
      bottom: theme.spacing(4.5)
    }
  };
});

var Login = function Login(props) {
  var classes = useStyle$1();
  var handleSuccess = props.handleSuccess,
      handleFail = props.handleFail,
      systemImages = props.systemImages,
      translations = props.translations,
      api = props.api;
  var isMobile = useMediaQuery('(max-width: 1200px)');

  var _a = useState(false),
      loading = _a[0],
      setLoading = _a[1];

  var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var email = useFormInput('', [{
    regex: /^.+$/,
    message: translations.emailBlank
  }, {
    regex: EMAIL_REGEX,
    message: translations.emailInvalid
  }]);
  var password = useFormInput('', [{
    regex: /^.+$/,
    message: translations.passwordBlank
  }]);

  function handleSubmit(e) {
    return __awaiter(this, void 0, void 0, function () {
      var loginResponse, userResponse;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            e.preventDefault();
            if (!email.validate()) return [2
            /*return*/
            , handleFail(translations.emailInvalid)];
            if (!password.validate()) return [2
            /*return*/
            , handleFail(translations.passwordMismatch)];
            setLoading(true);
            return [4
            /*yield*/
            , login(email.attrs.value, password.attrs.value, api)];

          case 1:
            loginResponse = _a.sent();
            return [4
            /*yield*/
            , getUser(loginResponse.data.auth_token, api)];

          case 2:
            userResponse = _a.sent();
            setLoading(false);

            if (!loginResponse.data.auth_token) {
              password.setInvalid(translations.loginFailed);
              return [2
              /*return*/
              , handleFail(translations.loginFailed)];
            }

            handleSuccess(loginResponse.data.auth_token, userResponse);
            return [2
            /*return*/
            ];
        }
      });
    });
  }

  return React.createElement(PageContainer, {
    className: classes.page
  }, React.createElement(Col, {
    align: 'center',
    justify: 'center',
    className: classes.leftCol
  }, React.createElement("form", {
    id: 'ca-login-form',
    onSubmit: handleSubmit,
    autoComplete: 'on',
    className: classes.form,
    noValidate: true
  }, React.createElement(FormGroup, null, React.createElement(Typography, {
    variant: 'h4',
    fontWeight: 'bold',
    className: clsx(classes.selfStart, classes.formTitle)
  }, translations.pageTitle), React.createElement(FormControl, {
    margin: 'dense'
  }, React.createElement(Input, _assign({
    id: 'ca-login-email'
  }, email.attrs, {
    type: 'email',
    variant: 'filled',
    name: 'email',
    autoComplete: 'on',
    label: translations.emailLabel
  }))), React.createElement(FormControl, {
    margin: 'dense'
  }, React.createElement(Input, _assign({}, password.attrs, {
    type: 'password',
    variant: 'filled',
    name: 'password',
    autoComplete: 'on',
    label: translations.passwordLabel
  }))), React.createElement(FormControl, {
    margin: 'dense',
    fullWidth: isMobile
  }, React.createElement(PrimaryButton, {
    type: 'submit',
    loading: loading,
    text: translations.submitButton,
    loadingText: translations.loadingSubmitButton,
    className: classes.selfEnd + " " + classes.submitButton
  })))), React.createElement(Link, {
    onClick: handleSubmit,
    className: classes.selfCenter
  }, React.createElement(Typography, {
    fontColor: dark50$1,
    fontWeight: 600
  }, translations.passwordForgotten)), React.createElement(Row, {
    className: classes.bottom
  }, React.createElement(Typography, {
    fontColor: dark50$1,
    fontWeight: 600
  }, translations.copyright + new Date().getFullYear()), React.createElement(Typography, {
    fontColor: dark50$1,
    fontWeight: 600
  }, "\xA0|\xA0"), React.createElement(Link, {
    href: 'https://copyrightagent.com/privacy/',
    target: '_blank'
  }, React.createElement(Typography, {
    fontColor: dark50$1,
    fontWeight: 600
  }, translations.privacy)), React.createElement(Typography, {
    fontColor: dark50$1,
    fontWeight: 600
  }, "\xA0|\xA0"), React.createElement(Link, {
    href: 'https://copyrightagent.com/contact-us/',
    target: '_blank'
  }, React.createElement(Typography, {
    fontColor: dark50$1,
    fontWeight: 600
  }, translations.support)))), React.createElement(RightPlaceholder, {
    logoSrc: systemImages.logoWithText,
    src: systemImages.publicPlaceholder,
    isMobile: isMobile
  }));
};

var red = '#CE505E';
var red10 = '#FAEDEF';
var green = '#48D2A0';
var dark = '#293833';
var dark50 = '#8E939B';
var dark75 = '#293241';
var useStyle = makeStyles(function (theme) {
  return {
    page: {
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center'
    },
    login: {
      width: 300,
      display: 'flex',
      flexDirection: 'column'
    },
    logo: {
      marginTop: 48,
      marginLeft: 48
    },
    email: {
      marginTop: 24,
      marginBottom: 12,
      '& input': {
        paddingLeft: 20
      },
      '& label': {
        paddingLeft: 15
      }
    },
    loadingText: {
      fontSize: 20,
      marginTop: 20,
      fontWeight: 800
    },
    emailSent: {
      maxWidth: 600,
      display: 'felx',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    emailSentTitle: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 12
    },
    emailSentTitleText: {
      marginRight: 12
    },
    emailDescription: {
      fontWeight: 400,
      fontSize: 14,
      color: dark75
    },
    emailAddress: {
      fontWeight: 600,
      fontSize: 14,
      marginTop: 5,
      marginBottom: 3,
      fontFamily: 'Open Sans, sans-serif'
    },
    troubleGettingMail: {
      color: dark,
      fontWeight: 600,
      textDecoration: 'none !important',
      marginTop: 24
    },
    error: {
      height: 50,
      width: '100%',
      color: red,
      marginTop: 12,
      borderRadius: 6,
      fontWeight: 600,
      fontSize: 14,
      textAlign: 'center',
      lineHeight: '50px',
      backgroundColor: red10
    },
    hidden: {
      visibility: 'hidden'
    },
    helpButtons: {
      height: 40,
      marginTop: 24
    },
    helpList: {
      display: 'list-item',
      listStyleType: 'disc',
      listStylePosition: 'inside',
      fontSize: 14,
      fontWeight: 400,
      color: dark75
    },
    helpResend: {
      marginTop: 24,
      fontSize: 14,
      fontWeight: 400,
      color: dark75
    },
    goBack: {
      height: 40,
      marginRight: 12,
      boxShadow: 'none !important'
    },
    resend: {
      height: 40,
      marginRight: 12
    },
    submitButton: {
      width: '100%',
      maxHeight: 40
    },
    terms: {
      color: dark50,
      fontWeight: 400,
      fontSize: 14
    },
    termsLink: {
      color: 'black',
      fontSize: 14,
      fontWeight: 400
    },
    bottom: {
      maxWidth: 750,
      textAlign: 'center',
      position: 'absolute',
      bottom: theme.spacing(4.5)
    }
  };
});

function me(token, api) {
  return __awaiter(this, void 0, void 0, function () {
    var config, res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          config = {
            method: 'get',
            url: api + "/me",
            headers: {
              'Content-Type': 'application/json',
              Authorization: token
            }
          };
          return [4
          /*yield*/
          , axios(config)];

        case 1:
          res = _a.sent();
          return [2
          /*return*/
          , res];
      }
    });
  });
}

var NewLogin = function NewLogin(props) {
  var login = props.login,
      token = props.token,
      api = props.api,
      translations = props.translations,
      tracking = props.tracking;
  var classes = useStyle();

  var _a = useState(false),
      emailSent = _a[0],
      setEmailSent = _a[1];

  var _b = useState(false),
      troubleGettingMail = _b[0],
      setTroubleGettingMail = _b[1];

  var _c = useState(''),
      error = _c[0],
      setError = _c[1];

  var _d = useState(''),
      email = _d[0],
      setEmail = _d[1];

  var _e = useState(false),
      loggedIn = _e[0],
      setLoggedIn = _e[1];

  var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  var checkIfLoggedIn = function checkIfLoggedIn() {
    return __awaiter(void 0, void 0, void 0, function () {
      var isLoggedIn;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , me(token, api)];

          case 1:
            isLoggedIn = _a.sent();
            if (!isLoggedIn) setLoggedIn(false); // Test this further

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  useEffect(function () {
    checkIfLoggedIn();
  }, []);

  var checkLogin = function checkLogin() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!EMAIL_REGEX.test(email)) return [2
        /*return*/
        , setError(translations.invalidEmail)];
        login(email);
        setEmailSent(true);
        setError('');

        if (tracking) {
          tracking('Continue with Email', {
            date: new Date(),
            email: email
          });
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  var handleTroubleGettingMail = function handleTroubleGettingMail() {
    setEmailSent(!emailSent);
    setTroubleGettingMail(!troubleGettingMail);
  };

  var handleGoBack = function handleGoBack() {
    return setTroubleGettingMail(!troubleGettingMail);
  };

  var handleKeypress = function handleKeypress(e) {
    if (e.charCode === 13) checkLogin();
  };

  var handleResend = function handleResend() {
    if (!email) {
      setTroubleGettingMail(!troubleGettingMail);
      return setError(translations.invalidEmail);
    }

    setTroubleGettingMail(!troubleGettingMail);
    setEmailSent(!emailSent);
    login(email);
    setEmailSent(true);
  };

  var renderEmailSent = function renderEmailSent() {
    var emailDescription = translations.checkEmailDescription;
    var emailDescriptionWithEmail = emailDescription.replace('<0>{{email}}</0>', email);
    return React.createElement(Row, {
      align: 'flex-start',
      className: classes.emailSent
    }, React.createElement("div", {
      className: classes.emailSentTitle
    }, React.createElement(Typography, {
      className: classes.emailSentTitleText,
      variant: 'h5',
      fontWeight: 600
    }, translations.checkEmail), React.createElement(Icons.CircleCheckIcon, {
      color: green
    })), React.createElement("div", {
      className: classes.emailDescription
    }, React.createElement(Trans, {
      components: [React.createElement("p", {
        key: 'email',
        className: classes.emailAddress
      })],
      values: {
        email: email
      }
    }, emailDescriptionWithEmail)), React.createElement(Link, {
      className: classes.troubleGettingMail,
      onClick: function onClick() {
        return handleTroubleGettingMail();
      },
      target: '_blank'
    }, "Trouble getting mail?"));
  };

  var renderTroubleGettingMail = function renderTroubleGettingMail() {
    return React.createElement(Row, {
      align: 'flex-start',
      className: classes.emailSent
    }, React.createElement("div", {
      className: classes.emailSentTitle
    }, React.createElement(Typography, {
      className: classes.emailSentTitleText,
      variant: 'h5',
      fontWeight: 600
    }, translations.helpTitle)), React.createElement("div", {
      className: classes.emailDescription
    }, React.createElement(Typography, {
      className: classes.helpList,
      variant: 'body2'
    }, translations.help1), React.createElement(Typography, {
      className: classes.helpList,
      variant: 'body2'
    }, translations.help2), React.createElement(Typography, {
      className: classes.helpList,
      variant: 'body2'
    }, translations.help3), React.createElement(Typography, {
      className: classes.helpList,
      variant: 'body2'
    }, translations.help4), React.createElement(Typography, {
      className: classes.helpResend,
      variant: 'body2'
    }, translations.help5)), React.createElement(Row, {
      className: classes.helpButtons
    }, React.createElement(SecondaryButton, {
      className: classes.goBack,
      onClick: function onClick() {
        return handleGoBack();
      },
      text: translations.goBack,
      type: 'button'
    }), React.createElement(PrimaryButton, {
      className: classes.resend,
      onClick: function onClick() {
        return handleResend();
      },
      type: 'button',
      text: translations.resend
    })));
  };

  var renderLogin = function renderLogin() {
    return React.createElement(Row, {
      className: classes.login
    }, React.createElement(Typography, {
      variant: 'h5',
      fontWeight: 600
    }, translations.loginTitle), React.createElement(Input, {
      type: 'email',
      variant: 'filled',
      className: classes.email,
      placeholder: translations.emailPlaceholder,
      value: email,
      onChange: function onChange(event) {
        return setEmail(event.target.value);
      },
      onKeyPress: handleKeypress
    }), React.createElement(PrimaryButton, {
      fullWidth: true,
      type: 'submit',
      className: classes.submitButton,
      text: translations.emailLogin,
      onClick: function onClick() {
        return checkLogin();
      }
    }), React.createElement("div", {
      className: clsx(classes.error, !error ? classes.hidden : '')
    }, error));
  };

  var getCurrentView = function getCurrentView() {
    if (emailSent) return renderEmailSent();
    if (troubleGettingMail) return renderTroubleGettingMail();
    return renderLogin();
  };

  return React.createElement(Fragment, null, loggedIn ? React.createElement(Fragment, null, React.createElement(CopyrightAgentLoader, null), React.createElement(Typography, {
    className: classes.loadingText
  }, translations.loading)) : React.createElement(Col, {
    align: 'center',
    justify: 'center'
  }, getCurrentView()));
};

export { Login, NewLogin };